<template>
  <div>
    <div class="ch-agr-box">
      <div class="ch-agr-title"> 注册协议</div>
      <div class="ch-agr-content-box">
        <!-- v-html="chContent" -->
        <div class="ch-agr-content">
          <p class="one">
            欢迎阅读供应商服务系统（以下简称系统）服务条款协议(下称“本协议”)。本协议阐述之条款和条件适用于您使用本系统所提供的采购招投标的各种工具和服务(下称“服务”)。根据《中华人民共和国合同法》、《中华人民共和国著作权法》、《全国人大常委会关于维护互联网安全的决定》、《中华人民共和国政府采购法》、《互联网信息服务管理办法》、《互联网电子公告服务管理规定》等有关法律、法规、规章，制订本协议。通过本系统注册成为本单位投标供应商信息库的用户，和以其他形式使用本供应商服务系统的用户，必须遵守本服务条款。
          </p>
          <p class="one item">
            1、产品及服务
          </p>
          <p class="two">
            1.1本协议所述服务仅在本系统内有效。本系统是指swssct.com及其所属网页。具体内容由本系统根据实际情况提供。
          </p>
          <p class="two">
            　 1.2本系统有权根据实际情况随时调整服务内容，并无需对任何使用者或任何第三方承担任何责任。
          </p>
          <p class="one item">
            2、使用规则
          </p>
          <p class="two">
            2.1使用者在申请及使用系统时，必须注册，并在注册时向系统平台提供准确完整的使用者资料，如使用者资料有任何变动，必须及时更新。本系统承诺，您在本系统中提供的所有资料将被依法保密。
          </p>
          <p class="two">
            2.2使用者注册成功后，该使用者帐号和密码由使用者负责保管，并仅限使用者自用，使用者不得将其帐号、密码转让或出借予他人使用；使用者应当对以其使用者帐号进行的所有活动和事件负法律责任。
          </p>
          <p class="two">
            2.3如使用者发现其帐号遭他人非法使用，应立即通知本系统。因黑客行为或使用者的保管疏忽导致帐号、密码遭他人非法使用，本系统不承担任何责任。
          </p>
          <p class="two">
            2.4以任何方式进入本系统同意服务协议即表示同意本协议所有内容，且您将接受本协议的全部条款约束。本系统可随时决定更改“条款”，如“条款”有变更会在系统上即刻发布，并自发布之时起立即生效。如果使用者拒绝接受修改后的协议，则使用者必须立即放弃本系统使用者身份，并立即停止使用本系统提供的服务；若使用者继续使用本系统提供的服务，则视为使用者接受修改后的协议。
            <!-- <br />
            2.根据诚信认证的有关要求，申请认证的用户须向交易平台提供包括但不限于《用户申请表》（加盖单位公章）、工商营业执照复印件（加盖单位公章）等资料。通过认证 的用户须执行年检制度。 -->
          </p>
          <p class="two">
            2.5使用者在使用系统平台服务过程中，必须遵循以下原则：
          </p>
          <p class="three">
            2.5.1 遵守中华人民共和国有关的法律和法规；
          </p>
          <p class="three">
            2.5.2 遵守所有与网络服务有关的网络协议、规定和程序；
          </p>
          <p class="three">
            2.5.3不得使用任何装置、软件或例行程序干预或试图干预本系统的正常运作。不得采取对任何将不合理或不合比例的庞大负载加诸本系统网络结构的行动；
          </p>
          <p class="three">
            2.5.4不得对任何资料作商业性利用，包括但不限于在未经本系统运营方书面批准的情况下，复制在本系统上展示的任何资料，包括系统的功能结构和画面等；
          </p>
          <p class="three">
            2.5.5 本系统著作权、商标权等知识产权、所有权、运作权和解释权等归乐山市绥山供应链科技有限公司唯一所有。
          </p>
          <p class="three">
            2.4.6本协议的解释、修改等权益乐山市绥山供应链科技有限公司享有。
          </p>
          <p class="one item">
            3、服务中断或终止
          </p>
          <p class="two">
            3.1对于因不可抗力造成的服务中断或其他缺陷（包括但不限于自然灾害、停电、外部网络中断、硬件故障、社会事件以及因网站所具有的特殊性质而产生的包括黑客攻击、电信部门技术调整导致的影响、政府管制而造成的暂时性关闭在内的任何影响网络正常运营的因素），本系统不承担任何责任，但将尽力减少因此而可能给使用者造成的损失和影响。
          </p>
          <p class="two">
            3.2若使用者提供的资料不真实，或使用者违反本协议中规定的任一条款，本系统有权随时中断或终止向使用者提供本协议项下的服务而无需对任何使用者或任何第三方承担任何责任。
          </p>
          <p class="one item">
            4、通知送达
          </p>
          <p class="two">
            本系统向使用者发送的所有通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等任一方式进行；该等通知于发送之日视为已送达使用者。
          </p>
          <p class="one item">
            5、免责声明
          </p>
          <p class="two">
            使用者使用本系统服务所存在的风险将完全由其自己承担；因其使用本系统服务而产生的一切后果也由其自己承担，本系统对任何使用者或任何第三方不承担任何责任。
          </p>
        </div>
      </div>
    </div>
    <div class="ch-agr-agree">
      <el-button type="primary" class="el-button" @click="onAgree">同意注册条款</el-button>
    </div>
  </div>
</template>

<script>
import announcement from "@/api/announcement/announcement"
export default {
  created() {
    // this.queryCompanyProfile(window.location.href);
  },
  data() {
    return {
      chContent: null
    }

  },
  methods: {
    onAgree() {
      this.$emit("agree");
    },
    queryCompanyProfile(url) {
      announcement.queryCompanyProfile({
        companyDomain: url
      }).then(
        res => {

          if (res.code === 200) {
            this.chContent = res.data.registrationTerms;
          }
        }
      )
    },
  },
};
</script>

<style lang="less" scoped>
.ch-agr-box {
  margin-top: 35px;
  padding: 35px 30px;
  border: 1px solid #efefef;

  >.ch-agr-title {
    font-size: 24px;
    color: #666666;
    font-weight: 400;
    text-align: center;
  }

  >.ch-agr-content-box {
    margin-top: 35px;
    padding: 31px 0;
    background-color: #f9f9f9;

    >.ch-agr-content {
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      padding: 0 31px;
      height: 400px;
      overflow: auto;
    }

    >.ch-agr-content::-webkit-scrollbar-thumb {
      background-color: #efefef;
    }
  }
}

.ch-agr-agree {
  margin-top: 35px;
  text-align: center;

  .el-button {
    padding-left: 40px;
    padding-right: 40px;
  }
}

.one {
  text-indent: 20px;
}

.item {
  font-weight: bold;
}

.two {
  text-indent: 25px;
}

.three {
  text-indent: 30px;
}</style>